import { useContext, useMemo } from 'react';
import { Select } from 'antd';
import dayjs from 'dayjs';
import { ToshibaContext } from '../../contexts/toshiba.context';
import { AppContext } from '../../contexts/AppContext';

type SaveModalData = {
  snapshotVersionN: string;
  comment: string;
  isMaster: boolean;
};

type VersionManagement = {
  id: string;
  snapshot: string;
  snapshotVersion: string;
  comment: string;
  updatedAt: Date;
  isDeleted: boolean;
  isMaster: boolean;
  isEdit: boolean;
  isPublic: boolean;
  copyFrom: string;
  createdBy: string;
};

const VersionManager: React.FC<any> = () => {
  const { color } = useContext(AppContext);
  const { snapshot, setSnapshot, setFilter } = useContext(ToshibaContext);

  // 下拉框数据
  const options = useMemo(
    () => ({
      snapshots: snapshot ? snapshot.versions.map(({ snapshot }) => ({ key: snapshot, label: snapshot, value: snapshot })) : [],
    }),
    [snapshot]
  );

  return (
    <>
      <div style={{ width: '100%', padding: '12px' }}>
        <div style={{ paddingBottom: '6px' }}>
          <div style={{ color: color.theme === 'light' ? color.primaryColor : '#fff' }}>データ断面</div>
          <Select
            style={{ width: '100%' }}
            value={snapshot?.currentSnapshot}
            options={options.snapshots}
            onChange={(currentSnapshot) => {
              const curIndex = snapshot.versions.findIndex((version) => version.snapshot === currentSnapshot);
              const targetSnapshot = snapshot.versions.length === curIndex + 1 ? currentSnapshot : snapshot.versions[curIndex + 1].snapshot;
              setFilter((filter) => ({
                ...filter,
                targetSnapshot,
              }));
              setSnapshot((snapshot) => {
                const curMonth = dayjs(currentSnapshot).month();
                const prevMonth = dayjs(targetSnapshot).month();
                let actualLabel = '';
                let forecastLabel = '';
                if (curMonth === 3) {
                  actualLabel = `4月実績`;
                  forecastLabel = `4-3月見込`;
                } else {
                  // actualLabel = `4-${month}月実績`;
                  actualLabel = `実績(4-${curMonth}月)`;
                  // forecastLabel = `${month + 1}-3月見込`;
                  forecastLabel = `見込(${curMonth + 1}-3月)`;
                }
                return {
                  ...snapshot,
                  currentSnapshot,
                  actualLabel,
                  forecastLabel,
                  curMonth: `${curMonth + 1}月`,
                  prevMonth: `${prevMonth + 1}月`,
                };
              });
            }}
          ></Select>
        </div>
      </div>
    </>
  );
};

export default VersionManager;
